export function noun(singular: string, plural: string, count: number): string {
    return count === 1 ? singular : plural;
}

export function ucfirst(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function validateEmail(email: string): boolean {
    const re = /^([\w-]+(?:(?:\.|\+)[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}
